import { z } from 'zod/v4';

export const PaginationSchema = z.object({
  totalObjects: z.number(),
  totalPages: z.number(),
  pageLimit: z.number(),
});

export const PaginationSchemaV2 = z.object({
  totalItems: z.number().default(0),
});

export const LegacyPaginationSchema = z.object({
  total_objects: z.number(),
  page_limit: z.number(),
  current_page: z.number(),
  last_page: z.number(),
});

export type Pagination = z.infer<typeof PaginationSchema>;
export type PaginationV2 = z.infer<typeof PaginationSchemaV2>;
export type LegacyPagination = z.infer<typeof LegacyPaginationSchema>;
